export const BOLT_BACKEND_TAGS = {
  discounts: 'discounts',
  billShock: 'billShock',
  salesReports: 'salesReports'
} as const
export type BoltBackendTag = (typeof BOLT_BACKEND_TAGS)[keyof typeof BOLT_BACKEND_TAGS]
